import { Injector, ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { Config, ConfigInitializerService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CatalogStatePersistenceService } from './catalog-state-persistence.service';
import { CatalogStoreModule } from './store/catalog-store.module';

function statePersistenceFactory(injector: Injector): () => Observable<Config> {
  return () => {
    const catalogStatePersistenceService = injector.get(CatalogStatePersistenceService);
    const configInit = injector.get(ConfigInitializerService);

    return configInit.getStable('context').pipe(
      tap(() => {
        catalogStatePersistenceService.sync();
      }),
    );
  };
}

@NgModule({
  imports: [CatalogStoreModule],
})
export class CatalogDataAccessModule {
  static forRoot(): ModuleWithProviders<CatalogDataAccessModule> {
    return {
      ngModule: CatalogDataAccessModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = statePersistenceFactory(inject(Injector));

          return initializerFn();
        }),
      ],
    };
  }
}
